import React, { useState } from "react";

import { UploadOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Divider, Form, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

const PropertyInspection = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="list-container">
      <div className="item-page-out">
        <Form className="item-page-container" layout="vertical">
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <Alert
                    message="Go and complete a full property inspection using the
                    appfolio inspection APP - We need a minimum of 100 photos on
                    each inspection completed"
                    type="info"
                  />
                </Col>
                <Col span={24}>
                  <Alert
                    message="place a codebox at the property and update the 
                    'manage physical lockbox' page in sayeagle with the property address."
                    type="info"
                  />
                </Col>
                <Col span={24}>
                  <Alert
                    message=" if you are not able to, select the next item to create one
                    for Gina to complete"
                    type="info"
                  />
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="end" gutter={[8, 0]}>
                <Col>
                  <Button>Skip</Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={handleComplete}
                    disabled={isDisabled}
                  >
                    Complete
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />

          <Row>
            <Col span={2}>
              <Avatar>KA</Avatar>
            </Col>
            <Col span={22}>
              <TextArea
                style={{
                  height: 200,
                  resize: "none",
                }}
                placeholder="Write a comment… Type @ to mention other users."
              />
            </Col>
          </Row>
          <Row justify="end" gutter={16}>
            <Col>
              <Upload>
                <Button style={{ marginTop: "10px" }}>
                  <UploadOutlined />
                </Button>
              </Upload>
            </Col>
            <Col>
              <Button style={{ marginTop: "10px" }}>Send</Button>
            </Col>{" "}
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default PropertyInspection;
